module.exports = __webpack_public_path__ + "img/image_24.f50d2d91.png";